import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=50fa18e8&scoped=true"
import script from "./ResultView.vue?vue&type=script&lang=js"
export * from "./ResultView.vue?vue&type=script&lang=js"
import style0 from "./ResultView.vue?vue&type=style&index=0&id=50fa18e8&prod&lang=less&scoped=true"
import style1 from "./ResultView.vue?vue&type=style&index=1&id=50fa18e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fa18e8",
  null
  
)

export default component.exports